// Type Guard for BasicReminderTask
export function isBasicReminderTask(task: BaseTask): task is BasicReminderTask {
  return task.type === 'basic_reminder';
}

// Type Guard for MedicationReminderTask
export function isMedicationReminderTask(task: BaseTask): task is MedicationReminderTask {
  return task.type === 'med_reminder';
}

// Type Guard for MedicationReminderGroupTask
export function isMedicationReminderGroupTask(task: BaseTask): task is MedicationReminderGroupTask {
  return task.type === 'med_reminder_group';
}

// Type Guard for ContentTask
export function isContentTask(task: BaseTask): task is ContentTask {
  return task.type === 'content';
}

// Type Guard for EncouragementTask
export function isEncouragementTask(task: BaseTask): task is EncouragementTask {
  return task.type === 'encouragement';
}

// Type Guard for PhysicalActivityTask
export function isPhysicalActivityTask(task: BaseTask): task is PhysicalActivityTask {
  return task.type === 'physical_act';
}

// Type Guard for SurveyTask
export function isSurveyTask(task: BaseTask): task is SurveyTask {
  return task.type === 'survey';
}

// Type Guard for QualtricsSurveyTask
export function isQualtricsSurveyTask(task: BaseTask): task is QualtricsSurveyTask {
  return task.type === 'qualtrics';
}

// Type Guard for GuidingCareAssessmentTask
export function isGuidingCareAssessmentTask(task: BaseTask): task is GuidingCareAssessmentTask {
  return task.type === 'guidingcare_assessment';
}
